import { useDesignMaxTheme } from "@/packages";
import { Box, Flex } from "@chakra-ui/react";
import { type RoomListType } from "../../otherRoomPreview.type";

export const OtherRoomPhotos = ({ rooms, currentIdx }: { rooms: RoomListType[]; currentIdx: number }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Flex position="relative" flex={isMobile ? "none" : "1"} h={isMobile ? "296px" : "936px"}>
            <Box
                maxW="656px"
                w="100%"
                position="absolute"
                bottom="0"
                left="0"
                h={isMobile ? "256px" : "836px"}
                background="#fbf6f2"
                borderBottomLeftRadius={isMobile ? "40px" : "88px"}
            />
            <Box
                position="absolute"
                right="0"
                top="0"
                maxW="656px"
                w="100%"
                h={isMobile ? "256px" : "836px"}
                borderTopRightRadius={isMobile ? "40px" : "88px"}
                overflow="hidden"
            >
                <Flex w="inherit" h="inherit" transition="0.3s" transform={`translateX(-${currentIdx * 100}%)`}>
                    {rooms.map((t) => (
                        <Box
                            flexShrink="0"
                            w="100%"
                            h="100%"
                            key={t.room_idx}
                            background={
                                t.imgList[0] ? `url(${t.imgList[0].img_URL})no-repeat center/cover` : "gray.100"
                            }
                        ></Box>
                    ))}
                </Flex>
            </Box>
        </Flex>
    );
};
